(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["player-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(root) {
      this.root = root;
      this.backgrounds = [...root.querySelectorAll('.hero-bg')];
      this.cards = [...root.querySelectorAll('.hero-card')];
      this.figures = [...root.querySelectorAll('.hero-figure')];
      this.dots = [...root.querySelectorAll('.hero-slider__dot')];
      this.ctaLink = root.querySelector('[data-cta]');
      this.ctaLabel = root.querySelector('[data-cta-label]');

      this.count = this.figures.length;
      if (this.count === 0) return;

      this.index = 0;
      this.isAnimating = false;
      this.autoplayId = null;

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.interval = this.readMs('--autoplay-interval', 4500);
      this.labelDelay = this.readMs('--dur-label', 220);

      this.slides = this.figures.map((fig) => ({
        text: fig.dataset.ctaText || '',
        href: fig.dataset.ctaHref || '#',
      }));

      this.bindEvents();
      this.syncInert();
      this.startAutoplay();
    }

    readMs(name, fallback) {
      const raw = getComputedStyle(this.root).getPropertyValue(name).trim();
      const value = parseFloat(raw);
      if (Number.isNaN(value)) return fallback;
      return raw.endsWith('ms') ? value : value * 1000;
    }

    bindEvents() {
      this.root.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          this.go(btn.dataset.dir === 'next' ? this.index + 1 : this.index - 1);
          this.restartAutoplay();
        });
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(Number(dot.dataset.index));
          this.restartAutoplay();
        });
      });

      this.root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restartAutoplay(); }
        if (e.key === 'ArrowLeft')  { this.go(this.index - 1); this.restartAutoplay(); }
      });

      this.root.addEventListener('mouseenter', () => this.stopAutoplay());
      this.root.addEventListener('mouseleave', () => this.restartAutoplay());
      this.root.addEventListener('focusin', () => this.stopAutoplay());
      this.root.addEventListener('focusout', () => this.restartAutoplay());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.stopAutoplay(); } else { this.restartAutoplay(); }
      });
    }

    go(target) {
      const next = (target % this.count + this.count) % this.count;
      if (next === this.index || this.isAnimating) return;

      const direction = this.shortestDirection(this.index, next);
      this.updateDots(next);
      this.toggleActive(this.backgrounds, next);
      this.toggleActive(this.cards, next);
      this.swapCta(next);
      this.slideFigures(this.figures[this.index], this.figures[next], direction);
      this.index = next;
    }

    shortestDirection(from, to) {
      const forward = (to - from + this.count) % this.count;
      const backward = (from - to + this.count) % this.count;
      return forward <= backward ? 1 : -1;
    }

    toggleActive(group, next) {
      if (group[this.index]) group[this.index].classList.remove('is-active');
      if (group[next]) group[next].classList.add('is-active');
    }

    slideFigures(from, to, direction) {
      if (this.reduceMotion) {
        from.dataset.state = direction === 1 ? 'next' : 'prev';
        to.dataset.state = 'current';
        this.syncInert();
        return;
      }

      this.isAnimating = true;
      to.classList.remove('is-entering', 'is-leaving');
      to.dataset.state = direction === 1 ? 'prev' : 'next';
      void to.offsetWidth;

      requestAnimationFrame(() => {
        from.classList.remove('is-entering');
        from.classList.add('is-leaving');
        from.dataset.state = direction === 1 ? 'next' : 'prev';

        to.classList.remove('is-leaving');
        to.classList.add('is-entering');
        to.dataset.state = 'current';
      });

      const onEnd = (e) => {
        if (e.propertyName !== 'transform') return;
        to.removeEventListener('transitionend', onEnd);
        to.classList.remove('is-entering');
        this.isAnimating = false;
        this.syncInert();
      };
      to.addEventListener('transitionend', onEnd);
    }

    swapCta(next) {
      if (!this.ctaLabel || !this.ctaLink) return;
      const slide = this.slides[next];
      this.ctaLabel.classList.add('is-swapping');
      const commit = () => {
        this.ctaLabel.textContent = slide.text;
        this.ctaLink.setAttribute('href', slide.href);
        this.ctaLabel.classList.remove('is-swapping');
      };
      if (this.reduceMotion) { commit(); } else { setTimeout(commit, this.labelDelay); }
    }

    updateDots(next) {
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));
    }

    syncInert() {
      this.cards.forEach((c, i) => c.toggleAttribute('inert', i !== this.index));
      this.figures.forEach((f, i) => f.toggleAttribute('inert', i !== this.index));
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.reduceMotion || this.count < 2) return;
      this.autoplayId = window.setInterval(() => this.go(this.index + 1), this.interval);
    }
    stopAutoplay() {
      window.clearInterval(this.autoplayId);
      this.autoplayId = null;
    }
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  function initHeroSliders(scope) {
    (scope || document).querySelectorAll('.hero-slider').forEach((el) => {
      if (el.dataset.hsInit) return;
      el.dataset.hsInit = '1';
      new HeroSlider(el);
    });
  }

  if (document.readyState !== 'loading') {
    initHeroSliders();
  } else {
    document.addEventListener('DOMContentLoaded', () => initHeroSliders());
  }

  // Reinicializa cuando el editor de temas recarga la sección
  document.addEventListener('shopify:section:load', (e) => initHeroSliders(e.target));

  } catch(e) { console.error(e); }
})();
})();
